"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceRecipe = void 0;
const utils_1 = require("../utils");
function reduceRecipe(reduceAndMap) {
    return function (reducer, initial) {
        return reduceAndMap.call(this, reducer, initial, utils_1.identity);
    };
}
exports.reduceRecipe = reduceRecipe;
